export default "__VITE_ASSET__5eb8302e__"